import { Component } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { MessageService } from '../../../services/messages/email.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../../../services/notification/notification.service';
import { NotificationRequest } from '../../../models/notification-request';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { CompanyInfo } from '../../../models/companyInfo';

@Component({
  selector: 'app-contact',
  imports: [HeroComponent, FormsModule, CommonModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent {
  name: string = '';
  email: string = '';
  subject: string = '';
  message: string = '';
  successMessage: string = '';
  errorMessage: string = '';
  userIds: any;
  companyInfo: CompanyInfo | null = null;

  constructor(
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
    private notificationService: NotificationService,
    private firestoreService: FirestoreService
  ) {}

  ngOnInit() {
    this.loadCompanyInfo();
    this.firestoreService.getAdminUserIds().subscribe({
      next: res => this.userIds = res
    });
  }

  sendMessage() {
    this.spinner.show();
    this.messageService.storeMessage(this.name, this.email, this.subject, this.message)
      .subscribe({
        next: () => {
          this.successMessage = 'Nachricht erfolgreich gespeichert!';
          this.errorMessage = '';
          setTimeout(() => {
            this.spinner.hide();
            Swal.fire({
              title: "Gut gemacht!",
              html: "Nachricht erfolgreich gesendet",
              icon: "success"
            });
          }, 2000);
          let request = new NotificationRequest();
          request.title = "Neue Nachricht erhalten";
          request.body = "Sie haben eine neue Nachricht von " + this.name;
          request.type = "MESSAGE";
          request.userIds = this.userIds;
          request.status = "UNREAD";
          this.notificationService.saveNotification(request).subscribe({
            next: res => {
              this.resetForm();
              console.log(res);
            }
          });
        },
        error: (err) => {
          this.spinner.hide();
          this.errorMessage = 'Fehler: ' + err.message;
          this.successMessage = '';
          setTimeout(() => {
            this.spinner.hide();
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
              confirmButtonText: "OK"
            });
          }, 2000);
        }
      });
  }

  private resetForm() {
    this.name = '';
    this.email = '';
    this.subject = '';
    this.message = '';
  }

  loadCompanyInfo() {
    this.firestoreService.getById('companyInfo', 'main').subscribe({
      next: (info) => {
        this.companyInfo = info || null;
      },
    });
  }

}